(function(){
  var t = null, busy = false;
  function cents(v){ v = parseInt(v, 10) || 0; return (v > 0 && v < 10000) ? v * 100 : v; }
  function fmt(c){ return 'S/ ' + (c / 100).toFixed(2); }
  function paint(el, sub){
    var g1 = cents(el.getAttribute('data-g1'));
    var g2 = cents(el.getAttribute('data-g2'));
    var g3 = cents(el.getAttribute('data-g3'));
    if (typeof sub !== 'number') sub = parseInt(el.getAttribute('data-subtotal'), 10) || 0;
    var pct;
    if (sub < g1)      pct = (sub / g1) * 30;
    else if (sub < g2) pct = 30 + ((sub - g1) / (g2 - g1)) * 32;
    else               pct = 62 + Math.min(1, (sub - g2) / (g3 - g2)) * 38;
    function q(s){ return el.querySelector(s); }
    if (!q('.cx-fill')) return;
    q('.cx-fill').style.width = Math.min(100, pct) + '%';
    q('.cx-m1').classList.toggle('on', sub >= g1);
    q('.cx-m2').classList.toggle('on', sub >= g2);
    q('.cx-m3').classList.toggle('on', sub >= g3);
    var msg;
    if (sub >= g3)      msg = '\uD83C\uDF89 \u00A1Desbloqueaste todas las recompensas: <b>env\u00EDo gratis</b> y <b>3 cuotas sin intereses</b>!';
    else if (sub >= g2) msg = '\u26A1 \u00A1<b>Env\u00EDo Express GRATIS</b> desbloqueado! Est\u00E1s a <b>' + fmt(g3 - sub) + '</b> de desbloquear las <b>3 cuotas sin intereses</b>';
    else if (sub >= g1) msg = '\uD83D\uDE9A \u00A1<b>Env\u00EDo Regular GRATIS</b> desbloqueado! Est\u00E1s a <b>' + fmt(g2 - sub) + '</b> de desbloquear el <b>Env\u00EDo Express GRATIS</b>';
    else if (sub > 0)   msg = 'Te faltan <b>' + fmt(g1 - sub) + '</b> para desbloquear tu <b>Env\u00EDo Regular GRATIS</b> \uD83D\uDE9A';
    else                msg = 'Agrega productos y empieza a desbloquear recompensas \uD83C\uDF81';
    /* FIX Chiquitex 2026-10: bucle de /cart.js — escribir solo si cambia */
    if (q('.cx-msg').innerHTML !== msg) q('.cx-msg').innerHTML = msg;
  }
  function runLocal(){
    document.querySelectorAll('.cx-goals').forEach(function(el){ paint(el); });
  }
  function sync(){
    clearTimeout(t);
    t = setTimeout(function(){
      if (busy) return;
      busy = true;
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
        busy = false;
        if (!c || typeof c.items_subtotal_price !== 'number') return;
        document.querySelectorAll('.cx-goals').forEach(function(el){
          el.setAttribute('data-subtotal', c.items_subtotal_price);
          paint(el, c.items_subtotal_price);
        });
      }).catch(function(){ busy = false; });
    }, 350);
  }
  if (document.readyState !== 'loading') runLocal();
  else document.addEventListener('DOMContentLoaded', runLocal);
  /* FIX Chiquitex 2026-10: bucle de /cart.js — ignorar tambien lo que pinta
     cx-cards.js (resumen, sticky, titulo del upsell) y el giro de los
     carruseles (.swiper-wrapper, p. ej. la barra de anuncios en loop). */
  new MutationObserver(function(muts){
    for (var i = 0; i < muts.length; i++){
      var tg = muts[i].target;
      if (tg && tg.closest && tg.closest('.cx-goals, #cx3-chiquipuntos, #cx3-cod, #cx4-breakdown, #cx5-sticky, .cart_page-recommend .minicart-heading, .swiper-wrapper')) return;
    }
    runLocal();
    sync();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
